import { IconNameType, PatientType, ProjectFileType, UserType } from '@/types'

export enum FeedTypeEnum {
  INQUIRY = 'inquiry',
  CALL = 'call',
  MESSAGE = 'message',
  EVENT = 'event',
  NOTE = 'note',
  CALL_NOTE = 'call_note',
  FILE = 'file',
  CLIENT_CHANGES = 'client_changes',
  PAYMENT = 'payment',
  PATIENT_JOURNEY = 'patient_journey',
}

export enum PaymentStatusEnum {
  PENDING = 'pending',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
}

export type ConversationTranscriptType = {
  phrase: string
  speaker: string
  start: number
}

export type FeedCommentType = {
  id: string
  user_id: UserType
  body: string
  created_at: string
  updated_at: string
}

export type FeedUserType = {
  id: number
  name: string
  email: string
}

export type FeedLocationType = {
  type: string
  location: string
}

export type PaymentMetadataType = {
  domain?: string
  lead_id?: number
  referer?: string
  website_id?: number
  entity_id?: string
  event_id?: string
  type?: string
  card_brand?: string
  card_exp_month?: number
  card_exp_year?: number
  card_funding?: string
  card_last4?: string
  card_name?: string
  amount_subtotal?: number
  amount_total?: number
  currency?: string
}

export type PaymentType = {
  id: string
  amount: string
  currency: string
  fee_amount: string
  status: PaymentStatusEnum
  status_label: string
  metadata: PaymentMetadataType
  created_at: string
  stripe_session_url?: string
}

export type FeedJourneyChangeType = {
  action: string
  after: Record<string, unknown>
  before: Record<string, unknown>
}

export type FeedType = {
  id: string
  type: FeedTypeEnum
  created_at: string
  updated_at: string
  full_name: string
  email: string
  phone_number: string
  phone_string?: string
  comments?: FeedCommentType[]
  user?: FeedUserType
  client?: PatientType

  // FeedTypeEnum.INQUIRY | FeedTypeEnum.MESSAGE
  message?: string

  // FeedTypeEnum.INQUIRY | FeedTypeEnum.EVENT | FeedTypeEnum.CALL
  marketing?: Record<string, string>

  // FeedTypeEnum.INQUIRY | FeedTypeEnum.EVENT
  customer_services?: string[]

  // FeedTypeEnum.INQUIRY
  source?: string
  location?: string[]
  procedures?: string[]
  price?: string[]

  // FeedTypeEnum.CALL
  prior_calls?: number
  total_calls?: number
  duration?: number
  recording_duration?: number
  device_type?: string
  direction?: string
  recording?: string
  recording_player?: string
  timeline_url?: string
  waveforms?: string[]
  conversational_transcript?: ConversationTranscriptType[]
  call_time?: string
  conversation_time?: string
  answered?: number
  files?: ProjectFileType[]

  // FeedTypeEnum.EVENT
  event_id?: string
  event_name?: string
  event_status?: string
  event_location?: FeedLocationType
  cancel_url?: string
  reschedule_url?: string
  start_time?: string
  end_time?: string
  rescheduled?: boolean
  guests?: string[]
  payment?: string[]
  questions_and_answers?: string[]
  cancellation?: string[]

  // FeedTypeEnum.NOTE | FeedTypeEnum.CALL_NOTE
  note?: string

  // FeedTypeEnum.NOTE
  clear_note?: string

  // FeedTypeEnum.CALL_NOTE
  datetime?: string

  // FeedTypeEnum.CLIENT_CHANGES
  changed_class?: string[]
  new?: Record<string, unknown>
  old?: Record<string, unknown>

  // FeedTypeEnum.MESSAGE
  thread_id?: string
  message_id?: string
  sender?: string
  sender_name?: string
  sender_email?: string
  client_number?: string
  company_number?: string

  // FeedTypeEnum.PAYMENT
  payment_id?: string
  amount?: string
  currency?: string
  fee_amount?: string
  metadata?: PaymentMetadataType

  // FeedTypeEnum.PATIENT_JOURNEY
  patient_journey_id?: string
  changes?: FeedJourneyChangeType
  procedure_names?: string

  // FeedTypeEnum.PAYMENT | FeedTypeEnum.PATIENT_JOURNEY
  status?: string

  // Generic
  messageCount?: number
}

export type ActivityDataType = {
  date: string
  icon: IconNameType
  title: string
  prefix: string
  time: string
  source?: string
  sourceType?: string
}

export type FeedFilterType = {
  created_at?: { start: string; end: string }
  selectedTypes: FeedTypeEnum[]
  selectedWebsites?: string[]
  direction?: 'desc' | 'asc'
}
